import { SessionFilterViewProps } from './model'
import React, { useEffect, useState } from 'react'
import DatePicker from 'react-datepicker'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { selectSessionFilterDateRange, setSessionFilterDateRange } from '../../store/sessionFilter/sessionFilter'
import { useSearchParams } from 'react-router-dom'

export const SessionDateFilter: React.FC<SessionFilterViewProps> = ({ filterType, disabled = false, onFilterChanged }) => {
  const dispatch = useAppDispatch()
  const sessionFilterDateRange = useAppSelector(selectSessionFilterDateRange)

  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([null, null])
  const [startDate, endDate] = dateRange
  const [searchParams] = useSearchParams()

  useEffect(() => {
    if (sessionFilterDateRange) {
      const [newStartDate, newEndDate] = sessionFilterDateRange
      setDateRange([new Date(newStartDate), new Date(newEndDate)])
    } else {
      setDateRange([null, null])
    }
  }, [sessionFilterDateRange])

  const handleDateFilterChanged = (update: [Date | null, Date | null]) => {
    update[1]?.setHours(23, 59, 59, 999)
    setDateRange(update)
    const [currentStartDate, currentEndDate] = update
    if (currentStartDate && currentEndDate) {
      dispatch(setSessionFilterDateRange([currentStartDate.toISOString(), currentEndDate.toISOString()]))
      searchParams.set('dateRange', JSON.stringify([currentStartDate.toISOString(), currentEndDate.toISOString()]))
      searchParams.delete('filterId')
    } else if (!currentStartDate && !currentEndDate) {
      dispatch(setSessionFilterDateRange(null))
      searchParams.delete('dateRange')
    }
    onFilterChanged?.(searchParams)
  }

  return (
    <div>
      <div className='mb-1'>Filter by date {startDate && endDate ? '(1)' : null}</div>
      <DatePicker
        disabled={disabled}
        wrapperClassName='w-100'
        className='form-control'
        selectsRange
        minDate={filterType === 'upcoming' ? new Date() : null}
        maxDate={filterType === 'past' ? new Date() : null}
        startDate={startDate}
        endDate={endDate}
        onChange={handleDateFilterChanged}
        isClearable
        placeholderText='Choose date'
        showIcon={!startDate && !endDate}
        toggleCalendarOnIconClick
        icon='bi bi-calendar4-week'
        calendarIconClassname='session-filter-calendar-icon'
      />
    </div>
  )
}
